import { makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: 50,
    },
    errorCode: {
        color: '#666666',
        fontSize: 256
    },
    errorContent: {
        color: "#b40000",
        fontWeight: 'bold',
    }
}));

export const Error404: React.FC = () => {
    const classes = useStyles();
    const location = useLocation();

    return (
        <div className={classes.container}>
            <div className={classes.errorCode}>404</div>
            <h1 className={classes.errorContent}>
                Page not found
            </h1>
            <h3>
                The requested URL {location.pathname} was not found on the server
            </h3>
        </div>
    );
}